import ApiService from "@/common/api.service";
import { SUBSCRIPTION, ERROR } from "./actions.type";
import { Subscriptions } from '@/firebase'

const state = {
  items: null
};
const mutations = {
  [SUBSCRIPTION.SET](state, items) {
    state.items = items;
  }
};

const getters = {
  subscriptions(state) {
    return state.items;
  }
};

const actions = {
  async [SUBSCRIPTION.FETCH](context, userId) {
    const snapshot = await Subscriptions.where('userId', '==', userId).get()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    if (snapshot.empty) {
      context.commit(ERROR.SET, 'No matching documents.');
      return;
    }
    const data = []
    snapshot.forEach(doc => {
      data.push(doc.data())
    });
    context.commit(SUBSCRIPTION.SET, data);
    return data
  },
  async [SUBSCRIPTION.GET_TRADER](context, accountId) {
    const asTrader = await Subscriptions.where('traderAccountId', '==', accountId).get()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    if (asTrader.empty) {
      context.commit(ERROR.SET, 'No matching documents as trader.');
    }
    const traders = []
    asTrader.forEach(doc => {
      traders.push(doc.data())
    });
    return traders
  },
  async [SUBSCRIPTION.GET_INVESTOR](context, accountId) {
    // investors
    const asInvestor = await Subscriptions.where('investorAccountId', '==', accountId).get()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    if (asInvestor.empty) {
      context.commit(ERROR.SET, 'No matching documents as investor.');
    }
    const investors = []
    asInvestor.forEach(doc => {
      investors.push(doc.data())
    });
    return investors
  },
  [SUBSCRIPTION.CREATE](context, schema) {
    return new Promise((resolve, reject) => {
      // set header to authorize
      ApiService.setHeader().then(() => {
        // fetch subscriptions
        ApiService.post(`subscriptions`, schema)
          .then(result => {
            resolve(result);
          })
          .catch(e => {
            context.commit(ERROR.SET, e);
            reject(e);
          });
      });
    });
  },
  [SUBSCRIPTION.DEL](context, schema) {
    return new Promise((resolve, reject) => {
      // set header to authorize
      ApiService.setHeader().then(() => {
        // fetch subscriptions
        ApiService.delete(`subscriptions/${schema.id}`)
          .then(result => {
            resolve(result);
          })
          .catch(e => {
            context.commit(ERROR.SET, e);
            reject(e);
          });
      });
    });
  },
  [SUBSCRIPTION.SUBSCRIBE_TOPIC](context, topicId, traderAccountId, investorAccountId) {
    var schema = {
      "name": [traderAccountId, ".", investorAccountId].join(),
      "topic": topicId,
      "pushConfig": {
        "pushEndpoint": ['https://api.tradingif.com/subscriptions/', traderAccountId, ".", investorAccountId, '/push'].join(),
        "attributes": {
          "traderAccountId": traderAccountId,
        }
      },
      "filter": ["attributes.traderAccountId=", traderAccountId].join()
    }
    ApiService.axios.put(
      "".join("https://pubsub.googleapis.com/v1/projects/tradingif/subscriptions/", topicId),
      schema
    )
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
